let monitoring: Promise<typeof import("./client-monitoring-sdk")> | undefined;

/** One SDK instance, shared by startup errors, error boundaries and navigation. */
export function loadClientMonitoring() {
  return monitoring ??= import("./client-monitoring-sdk").then((sdk) => {
    sdk.initialize();
    return sdk;
  });
}

export function captureClientException(error: unknown) {
  void loadClientMonitoring().then((sdk) => sdk.captureException(error)).catch(() => {});
}
